var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"size":"sm","variant":"primary","aria-label":"reload"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"fa fa-refresh"})])}
var staticRenderFns = []

export { render, staticRenderFns }